import Box from "@mui/material/Box";
import React from "react";

export const BrandclubTextMessageVerbiage = ({
  sx,
}: {
  sx?: React.ComponentProps<typeof Box>["sx"];
}) => {
  return (
    <Box
      component="p"
      sx={{
        fontSize: 12,
        fontWeight: 500,
        marginTop: 1,
        color: "text.primary",
        textAlign: "center",
        opacity: 0.3,
        ...sx,
      }}
    >
      {`By providing your phone number, you agree to receive text messages from Brandclub. Message and data rates may apply. Reply STOP to opt out.`}
    </Box>
  );
};

export default BrandclubTextMessageVerbiage;
